import React from "react";
import Helper from "../../../Helper";

interface MapObjectIframeViewerProps {
    iframe: string;
}

const MapObjectIframeViewer: React.FC<MapObjectIframeViewerProps> = (props) => {
    return (
        <div className=" aspect-video mb-6 rounded-lg!">
            <div className="w-full h-full">
                {Helper.isHTMLBlock(props.iframe) ? (
                    <div
                        className="w-full h-full leading-loose"
                        dangerouslySetInnerHTML={{ __html: props.iframe }}
                    ></div>
                ) : (
                    <iframe src={props.iframe} className="w-full h-full" />
                )}
            </div>
        </div>
    );
};

export default MapObjectIframeViewer;
